import { Theme, styled } from '@mui/material/styles'

export const StyledMainLogo = styled('img')`
  margin: 0 31px;
  width: 290px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    width: 150px;
    height: 20px;
    margin: 0 12px;
  }
`
